import * as React from 'react';

import { use$ } from '@legendapp/state/react';
import { styled } from '@volkswagen-onehub/components-core';

import TrimlineDropDownContainer from '../trimline-selection/trimine-dropdown-container';

import { DeviceType, deviceSettingStore, fullscreenStore, interiorStore, rootStore } from '../../store';
import { testId } from '../../test-utils/constants';
import { ActionWrapperBackgroundMixin } from '../action-wrapper-background.mixin';
import { FullscreenButton } from '../fullscreen/fullscreen-button';
import BadgeCta from './reference-badge';

const TopHeader = () => {
	const [_, currentModelValue] = use$(rootStore.currentModel);
	const trimName = currentModelValue.vehicleConfiguration?.trimName || '$$MISSING_TRANSLATION_KEY$$';

	const isMobileDevice = use$(deviceSettingStore.isMobileDevice);
	const isIpad = use$(deviceSettingStore.deviceType) === DeviceType.iPad;
	const isHidden = use$(interiorStore.isHidden);
	const { isFullscreenMode, isFullscreenAvailableOnDevice } = use$(fullscreenStore);

	return (
		<Wrapper data-testid={testId('Header_Wrapper_Fullscreen')} $isHidden={isHidden}>
			<TitleTrimlineWrapper $isIpad={!!isIpad}>
				<TrimlineDropDownContainer title={trimName} testId={testId('Trimeline_Selection_Fullscreen')} />

				{!isFullscreenMode && <BadgeCta />}
			</TitleTrimlineWrapper>
			{isFullscreenAvailableOnDevice && isMobileDevice && <FullscreenButton />}
		</Wrapper>
	);
};

const Wrapper = styled.div<{ $isHidden?: boolean }>`
	position: relative;
	grid-column: 1 / 25;
	grid-row: 1 / 1;

	transition: opacity 0.3s ease;
	opacity: ${({ $isHidden }) => ($isHidden ? '0' : '1')};

	display: flex;

	justify-content: space-between;
	align-items: center;

	border-bottom-left-radius: ${props => props.theme.size.static150};
	border-bottom-right-radius: ${props => props.theme.size.static150};

	${ActionWrapperBackgroundMixin(true)}
`;

const TitleTrimlineWrapper = styled.div<{ $isIpad: boolean }>`
	display: flex;
	width: 100%;

	// Since dropdown or header title will always exist we can use it to provide the spacing
	padding-top: ${({ theme }) => theme.size.static150};
	padding-bottom: ${({ theme }) => theme.size.static150};

	margin-left: ${({ theme, $isIpad }) => {
		// iPad fullscreen button condition there's no size big enough :(
		const ltr = theme.direction === 'ltr';
		return ltr && $isIpad ? '6rem' : theme.size.static250;
	}};
	margin-right: ${({ theme }) => theme.size.static250};
`;

export default TopHeader;
